(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moonsmc-signature-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mm-hero-photo-picker')) {
    customElements.define('mm-hero-photo-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.photos = [...this.querySelectorAll('[data-slide]')];
        if (!this.photos.length) return;
        this.controller = new AbortController();
        this.request = (this.request || 0) + 1;
        this.pendingLoads = new Set();
        this.loads = new Map();
        this.initialReady = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.paused ?? this.motion.matches;
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        const options = { signal: this.controller.signal };
        this.querySelector('[data-controls]')?.toggleAttribute('hidden', this.photos.length < 2);
        this.querySelector('[data-toggle]')?.toggleAttribute('hidden', this.dataset.editor === 'true');
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.advance(-1), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.advance(1), options);
        this.querySelector('[data-toggle]')?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', event => {
          if (event.matches) this.paused = true;
          this.schedule();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.photos.findIndex(photo => photo.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.show(index);
        }, options);
        this.render(Math.min(this.index || 0, this.photos.length - 1), false);
        this.schedule();
        const controller = this.controller;
        this.ready(this.index).then(() => {
          if (controller === this.controller) {
            this.initialReady = true;
            this.schedule();
          }
        });
      }

      disconnectedCallback() {
        this.request = (this.request || 0) + 1;
        this.clearTimers();
        this.animation?.cancel();
        this.pendingLoads?.forEach(cancel => cancel());
        this.controller?.abort();
        this.controller = null;
      }

      canPlay() {
        return this.controller && this.initialReady && this.photos.length > 1 && this.dataset.editor !== 'true' && !this.paused && !this.hovered && !this.focused && !document.hidden;
      }

      clearTimers() {
        clearTimeout(this.timer);
        clearTimeout(this.preloadTimer);
      }

      schedule() {
        this.clearTimers();
        const toggle = this.querySelector('[data-toggle]');
        toggle?.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.querySelector('[data-pause-icon]')?.toggleAttribute('hidden', this.paused);
        this.querySelector('[data-play-icon]')?.toggleAttribute('hidden', !this.paused);
        if (!this.canPlay()) return;
        this.preloadTimer = setTimeout(() => this.ready((this.index + 1) % this.photos.length), 1500);
        this.timer = setTimeout(() => this.advance(1, true), 6000);
      }

      ready(index) {
        const image = this.photos[index]?.querySelector('img');
        if (!image || !this.controller) return Promise.resolve(false);
        image.loading = 'eager';
        image.fetchPriority = index === 0 ? 'high' : 'low';
        if (image.complete) return Promise.resolve(image.naturalWidth > 0);
        if (this.loads.has(image)) return this.loads.get(image);
        const signal = this.controller.signal;
        const promise = new Promise(resolve => {
          let finished = false;
          const finish = success => {
            if (finished) return;
            finished = true;
            clearTimeout(timeout);
            signal.removeEventListener('abort', cancel);
            this.pendingLoads.delete(cancel);
            resolve(success);
          };
          const cancel = () => finish(false);
          const timeout = setTimeout(cancel, 4000);
          this.pendingLoads.add(cancel);
          signal.addEventListener('abort', cancel, { once: true });
          image.decode().then(() => finish(image.naturalWidth > 0), () => finish(false));
        });
        this.loads.set(image, promise);
        promise.then(() => { if (this.loads.get(image) === promise) this.loads.delete(image); });
        return promise;
      }

      advance(step, automatic = false) {
        return this.change((this.index + step + this.photos.length) % this.photos.length, step, automatic);
      }

      show(index) {
        return this.change(index);
      }

      async change(index, step = 0, automatic = false) {
        if (!this.controller) return;
        const controller = this.controller;
        const request = ++this.request;
        this.clearTimers();
        for (let attempt = 0; attempt < (step ? this.photos.length - 1 : 1); attempt++) {
          const ready = await this.ready(index);
          if (controller !== this.controller || request !== this.request) return;
          if (automatic && !this.canPlay()) break;
          if (ready) {
            this.render(index, true);
            this.initialReady = true;
            break;
          }
          index = (index + step + this.photos.length) % this.photos.length;
        }
        this.schedule();
      }

      render(index, animate) {
        const previous = this.photos[this.index];
        const photo = this.photos[index];
        this.animation?.cancel();
        this.animation = null;
        this.photos.forEach((photo, position) => {
          photo.hidden = position !== index;
          photo.setAttribute('aria-hidden', String(position !== index));
          photo.style.zIndex = '';
        });
        if (animate && previous && previous !== photo && !this.motion.matches && photo.animate) {
          previous.hidden = false;
          photo.style.zIndex = '1';
          const animation = photo.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 550, easing: 'ease-out' });
          this.animation = animation;
          animation.finished.then(() => {
            if (this.animation !== animation) return;
            previous.hidden = true;
            photo.style.zIndex = '';
            this.animation = null;
          }).catch(() => {});
        }
        this.index = index;
        this.selectedId = photo.dataset.blockId;
        this.dataset.photoReady = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
